module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-payment/landpayment-grid/landpayment-grid.component.css
// module id = ./src/app/landprocurement/land-payment/landpayment-grid/landpayment-grid.component.css
// module chunks = main